var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_232_7747",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.5C7 16.5 12.625 12 12.625 7.125C12.625 4.0185 10.1065 1.5 7 1.5C3.8935 1.5 1.375 4.0185 1.375 7.125C1.375 12 7 16.5 7 16.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.375C7.29547 9.375 7.58806 9.3168 7.86104 9.20373C8.13402 9.09066 8.38206 8.92492 8.59099 8.71599C8.79992 8.50706 8.96566 8.25902 9.07873 7.98604C9.1918 7.71306 9.25 7.42047 9.25 7.125C9.25 6.82953 9.1918 6.53694 9.07873 6.26396C8.96566 5.99098 8.79992 5.74294 8.59099 5.53401C8.38206 5.32508 8.13402 5.15934 7.86104 5.04627C7.58806 4.9332 7.29547 4.875 7 4.875C6.40326 4.875 5.83097 5.11205 5.40901 5.53401C4.98705 5.95597 4.75 6.52826 4.75 7.125C4.75 7.72174 4.98705 8.29403 5.40901 8.71599C5.83097 9.13795 6.40326 9.375 7 9.375Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_232_7747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2 0H16V18H-2V0Z",
    fill: "#F26A1C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.38cc8a448b72a0b4a059942b7c1cb2a4.svg";
export { ForwardRef as ReactComponent };